export default __webpack_public_path__ + "static/media/notice-yellow.aaa0efde.svg";